import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import './assets/sass/app.scss'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css"
import VCalendar from 'v-calendar'
import '@vueform/multiselect/themes/default.css'
import 'v-calendar/dist/style.css'
try {
    window.bootstrap = require('bootstrap');
} catch (e) {}




createApp(App)
.use(Toast)
.use(router)
.use(VCalendar)
.mount('#app');

// To prevent quiting from dropdown on click inside it.
document.querySelector(".account-dropdown").addEventListener("click", function (e) {
    e.stopPropagation();
});